// import { TpWebGl2DContext, WebGL2DRenderTypes, perfTestStart, perfTestStop } from './interfaces';
// import { mulberry32 } from './randomData';
// import { setWebGLZoomPan } from './utils';

import { TpWebGL2DRenderDataColoredTriangles, TpWebGLRenderDataLayer } from './interface-renderData';
import { TpWebGL2DRenderLayer, TpWebGl2DContext, WebGL2DRenderTypes } from './interfaces';
import { setWebGLZoomPan } from './utils';

export interface TpRenderColoredTriangles {
  renderType: WebGL2DRenderTypes.COLORED_TRIANGLES;
  ctx: TpWebGl2DContext;
  layerId: string;
  pointCount: number;
  positionBuffer: any;
  colorBuffer: any;
}

function create(ctx: TpWebGl2DContext, dataInp: TpWebGLRenderDataLayer): TpRenderColoredTriangles {
  const gl = ctx.gl;
  const data = dataInp as TpWebGL2DRenderDataColoredTriangles;

  // Create a buffer for the vertices
  const positionBuffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
  gl.bufferData(gl.ARRAY_BUFFER, data.posits, gl.STATIC_DRAW);

  // Create a buffer for the colors
  const colorBuffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer);
  gl.bufferData(gl.ARRAY_BUFFER, data.colors, gl.STATIC_DRAW);

  const renderCtx: TpRenderColoredTriangles = {
    renderType: WebGL2DRenderTypes.COLORED_TRIANGLES,
    layerId: data.layerId,
    ctx,
    positionBuffer,
    colorBuffer,
    pointCount: data.posits.length / 2,
  };

  return renderCtx;
}

function updateData(rendererInp: TpWebGL2DRenderLayer, dataInp: TpWebGLRenderDataLayer) {
  const renderer = rendererInp as TpRenderColoredTriangles;
  const gl = renderer.ctx.gl;
  const data = dataInp as TpWebGL2DRenderDataColoredTriangles;

  // NOTE: as a future improvement, we only update the buffer if the floatarray was changed (simple reference check)

  gl.bindBuffer(gl.ARRAY_BUFFER, renderer.positionBuffer);
  gl.bufferData(gl.ARRAY_BUFFER, data.posits, gl.STATIC_DRAW);

  gl.bindBuffer(gl.ARRAY_BUFFER, renderer.colorBuffer);
  gl.bufferData(gl.ARRAY_BUFFER, data.colors, gl.STATIC_DRAW);

  renderer.pointCount = data.posits.length / 2;
}

function performRender(webGlCtx: TpWebGl2DContext, renderCtxInp: TpWebGL2DRenderLayer) {
  const renderCtx = renderCtxInp as TpRenderColoredTriangles;
  const gl = webGlCtx.gl;

  const myProgram = webGlCtx.programContextColoredTriangles;
  gl.useProgram(myProgram.program);

  setWebGLZoomPan(webGlCtx, myProgram);

  gl.enable(gl.BLEND);
  gl.blendEquation(gl.FUNC_ADD);
  //gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA); // most logical choice for premultipliedAlpha ?
  gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);

  // Vertices
  gl.enableVertexAttribArray(myProgram.locAttribPosition);
  gl.bindBuffer(gl.ARRAY_BUFFER, renderCtx.positionBuffer);
  gl.vertexAttribPointer(
    myProgram.locAttribPosition,
    2, // 2 components per iteration (because only two coordinates per vertex are provided)
    gl.FLOAT,
    false, // don't normalize the data
    0, // stride 0 = move forward size * sizeof(type) each iteration to get the next position
    0, // offset
  );

  // Colors
  gl.bindBuffer(gl.ARRAY_BUFFER, renderCtx.colorBuffer);
  gl.vertexAttribPointer(
    myProgram.locAttribColor,
    4, // numComponents
    gl.FLOAT,
    false, // no normalization
    0, // auto stride
    0, // offset
  );
  gl.enableVertexAttribArray(myProgram.locAttribColor);

  gl.drawArrays(
    gl.TRIANGLES,
    0, // offset
    renderCtx.pointCount, //count
  );
}

export const webGl2DColoredTriangles = {
  create,
  updateData,
  performRender,
};

// export function addRenderColoredTriangles(ctx: TpWebGl2DContext) {
//   const gl = ctx.gl;

//   const vertexData = createVertexData();

//   // Create a buffer for the vertices
//   const positionBuffer = gl.createBuffer();
//   gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
//   gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertexData.vertices_xy), gl.STATIC_DRAW);

//   // Create a buffer for the colors
//   const colorBuffer = gl.createBuffer();
//   gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer);
//   gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertexData.colors_rgba), gl.STATIC_DRAW);

//   const renderCtx: TpRenderColoredTriangles = {
//     renderType: WebGL2DRenderTypes.COLORED_TRIANGLES,
//     positionBuffer,
//     colorBuffer,
//     vertexData,
//   };

//   ctx.renderLayers.push(renderCtx);
// }

// export function performRenderColoredTriangles(webGlCtx: TpWebGl2DContext, renderCtx: TpRenderColoredTriangles) {
//   const gl = webGlCtx.gl;

//   gl.useProgram(webGlCtx.programContextColoredTriangles.program);

//   setWebGLZoomPan(webGlCtx, webGlCtx.programContextColoredTriangles);

//   // Vertices
//   gl.enableVertexAttribArray(webGlCtx.programContextColoredTriangles.locAttribPosition);
//   gl.bindBuffer(gl.ARRAY_BUFFER, renderCtx.positionBuffer);
//   gl.vertexAttribPointer(
//     webGlCtx.programContextColoredTriangles.locAttribPosition,
//     2, // 2 components per iteration (because only two coordinates per vertex are provided)
//     gl.FLOAT,
//     false, // don't normalize the data
//     0, // stride is automatic
//     0, // offset
//   );

//   // Colors
//   gl.enableVertexAttribArray(webGlCtx.programContextColoredTriangles.locAttribColor);
//   gl.bindBuffer(gl.ARRAY_BUFFER, renderCtx.colorBuffer);
//   gl.vertexAttribPointer(
//     webGlCtx.programContextColoredTriangles.locAttribColor,
//     4, // number of components
//     gl.FLOAT,
//     false, // no normalization
//     0, // stride is automatic
//     0, // offset
//   );

//   gl.drawArrays(
//     gl.TRIANGLES,
//     0, // offset
//     renderCtx.vertexData.vertexCount * 3, // count
//   );
// }
